<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>{{ titulo }}</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text
      style="height: 100%;"
      class="pa-0"
    >
      <v-data-table
        must-sort
        :headers="tipo === 'POP' ? headers : headersComprobantes"
        :items="items"
        :pagination.sync="paginacion"
        :total-items="totalItems"
        :rows-per-page-items="itemsPorPagina"
        :loading="cargando"
        class="elevation-1"
      >
        <v-progress-linear
          v-slot:progress
          color="blue"
          indeterminate
          v-if="cargando"
        ></v-progress-linear>
        <template v-slot:items="props">
          <tr
            v-if="tipo === 'POP'"
            @click="seleccionarOrden(props.item)"
            :class="{ secondary: itemSeleccionado && props.item.id === itemSeleccionado.id }"
          >
            <td class="text-xs-left">{{ props.item.id }}</td>
            <td class="text-xs-left">
              {{ props.item.proyecto_pago_version.proyecto_pago.concepto }}
            </td>
            <td class="text-xs-left">{{ props.item.proyecto_pago_version.estado.nombre }}</td>
            <td class="text-xs-left">
              {{ props.item.proyecto_pago_version.proyecto_pago.fecha_pago | formatoFecha }}
            </td>
            <td class="text-xs-left">{{ props.item.institucion | nombreCentro }}</td>
            <td class="text-xs-left">{{ props.item.proyecto_pago_version.proyecto_pago.id }}</td>
            <td class="text-xs-right">{{ props.item.importe | currency }}</td>
          </tr>
          <tr v-else>
            <td class="text-xs-left">{{ props.item.comprobante.fecha | formatoFecha }}</td>
            <td class="text-xs-left">{{ props.item.comprobante | cabeceraComprobante }}</td>
            <td class="text-xs-left">
              {{ props.item.comprobante.facturado_por | nombreCentro }}
            </td>
            <td class="text-xs-left">
              {{
                  props.item.comprobante.facturado_obra_social
                    ? props.item.comprobante.facturado_obra_social.nombre
                    : $options.filters.nombreCentro(props.item.comprobante.facturado_institucion)
                }}
            </td>
            <td class="text-xs-left">
              {{ props.item.comprobante.concepto_descripcion }}
            </td>

            <td class="text-xs-right">
              <span
                class=" red--text"
                v-if="info.comprobantesRestan.indexOf(props.item.comprobante.tipo_comprobante.codigo) > -1"
              >
                {{ (props.item.importe_pagado * -1) | currency }}
              </span>
              <span v-else>
                {{ props.item.importe_pagado | currency }}
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>

      <template v-if="itemSeleccionado">
        <h4 class="px-3 my-3 secondary--text">COMPROBANTES ASOCIADOS A LA ORDEN DE PAGO</h4>

        <v-data-table
          must-sort
          :headers="headersComprobantes"
          :items="itemsComprobantes"
          :pagination.sync="paginacionComprobantes"
          :total-items="totalItemsComprobantes"
          :rows-per-page-items="itemsPorPagina"
          :loading="cargandoComprobantes"
          class="elevation-1"
        >
          <v-progress-linear
            v-slot:progress
            color="blue"
            indeterminate
            v-if="cargandoComprobantes"
          ></v-progress-linear>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">{{ props.item.comprobante.fecha | formatoFecha }}</td>
              <td class="text-xs-left">{{ props.item.comprobante | cabeceraComprobante }}</td>
              <td class="text-xs-left">
                {{ props.item.comprobante.facturado_por | nombreCentro }}
              </td>
              <td class="text-xs-left">
                {{
                  props.item.comprobante.facturado_obra_social
                    ? props.item.comprobante.facturado_obra_social.nombre
                    : $options.filters.nombreCentro(props.item.comprobante.facturado_institucion)
                }}
              </td>
              <td class="text-xs-left">
                {{ props.item.comprobante.concepto_descripcion }}
              </td>

              <td class="text-xs-right">
                <span
                  class=" red--text"
                  v-if="info.comprobantesRestan.indexOf(props.item.comprobante.tipo_comprobante.codigo) > -1"
                >
                  {{ (props.item.importe_pagado * -1) | currency }}
                </span>
                <span v-else>
                  {{ props.item.importe_pagado | currency }}
                </span>
              </td>
            </tr>
          </template>
          <template
            slot="footer"
            v-if="itemsComprobantes.length > 0"
          >
            <tr class="grey lighten-3">
              <td colspan="5"></td>
              <td class="text-xs-right font-weight-bold">
                {{ sumaImporteItemsComprobantes(itemsComprobantes) | currency }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="false"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { formatoFecha, nombreCentro, cabeceraComprobante } from '@/helpers/filtros'
import Comprobante from '@/api/comprobante'
import ProyectoPago from '@/api/proyectoPago'
import BotonesCancelarGuardar from '@/components/Botones/BotonesCancelarGuardar'

export default {
  name: 'FacturacionOrdenesPago',
  components: {
    BotonesCancelarGuardar
  },
  filters: {
    formatoFecha,
    nombreCentro,
    cabeceraComprobante
  },
  props: {
    titulo: {
      type: String
    },
    item: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      default: 'POP'
    }
  },
  data () {
    return {
      filtros: {
        search: null
      },
      filtrosComprobantes: {
        search: null
      },
      totalItems: 0,
      headers: [
        { text: 'N°', value: 'id', sortable: false },
        { text: 'Concepto', value: 'id', sortable: false },
        { text: 'Estado ', value: 'estado_id', sortable: false },
        { text: 'Fecha Emisión', value: 'id', sortable: false },
        { text: 'Centro', value: 'institucion_id', sortable: false },
        { text: 'N° Proyecto Pago', value: 'id', sortable: false },
        {
          text: 'Importe',
          value: 'importe',
          sortable: false,
          align: 'right'
        }
      ],
      items: [],
      paginacion: {},
      totalItemsComprobantes: 0,
      itemsComprobantes: [],
      headersComprobantes: [
        { text: 'Fecha', value: 'id', sortable: false },
        { text: 'Cabecera', value: 'id', sortable: false },
        { text: 'De', value: 'id', sortable: false },
        { text: 'Para', value: 'id', sortable: false },
        { text: 'Concepto', value: 'id', sortable: false },
        {
          text: 'Importe OP',
          value: 'importe_pagado',
          sortable: false,
          align: 'right'
        }
      ],
      paginacionComprobantes: {},
      itemsPorPagina: [20, 50, 100],
      cargando: false,
      cargandoComprobantes: false,
      referencia: {
        type: String,
        required: true
      },
      itemSeleccionado: null,
      info: {
        comprobantesRestan: ['NDI', 'NDF', 'ND', 'NDC', 'FAC', 'NCT']
      }
    }
  },
  watch: {
    paginacion: {
      handler () {
        this.filtrarDatos()
      },
      deep: true
    },
    paginacionComprobantes: {
      handler () {
        this.filtrarComprobantes()
      },
      deep: true
    }
  },
  mounted () {
    let vm = this
    vm.filtrar('ordenes')
  },
  methods: {
    filtrar (tabla) {
      let vm = this
      if (tabla === 'ordenes') {
        vm.filtros.page = 1
        vm.filtrarDatos()
      } else {
        vm.filtrosComprobantes.page = 1
        vm.filtrarComprobantes()
      }
    },

    filtrarDatos () {
      let vm = this
      let _filtros = _.assign({}, vm.filtros)

      if (vm.cargando) {
        return false
      }

      _filtros.page = vm.paginacion.page
      _filtros.perPage = vm.paginacion.rowsPerPage
      _filtros.orderBy = vm.paginacion.sortBy
      _filtros.sortedBy = vm.paginacion.descending ? 'desc' : 'asc'

      vm.cargando = true
      vm.metodoFiltrar('ordenes', _filtros).then(
        data => {
          vm.items.lenght = 0
          vm.items = data.data
          vm.totalItems = data.total
          vm.cargando = false
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargando = false
        }
      )
    },
    filtrarComprobantes () {
      let vm = this
      let _filtros = _.assign({}, vm.filtrosComprobantes)

      if (vm.cargandoComprobantes) {
        return false
      }

      _filtros.page = vm.paginacionComprobantes.page
      _filtros.perPage = vm.paginacionComprobantes.rowsPerPage
      _filtros.orderBy = vm.paginacionComprobantes.sortBy
      _filtros.sortedBy = vm.paginacionComprobantes.descending ? 'desc' : 'asc'

      vm.cargandoComprobantes = true
      vm.metodoFiltrar('comprobantes', _filtros).then(
        data => {
          vm.itemsComprobantes.lenght = 0
          vm.itemsComprobantes = data.data
          vm.totalItemsComprobantes = data.total
          vm.cargandoComprobantes = false
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargandoComprobantes = false
        }
      )
    },
    seleccionarOrden (item) {
      this.itemSeleccionado = item
      this.filtrar('comprobantes')
    },

    cerrar () {
      this.$emit('alCerrar')
    },

    metodoFiltrar (tabla, filtros) {
      let vm = this

      if (tabla === 'ordenes') {
        filtros.por = vm.por
        filtros.comprobante_id = vm.item.id
        return Comprobante.obtenerOrdenesPago(vm.item.id, filtros)
      } else {
        filtros.por = vm.por
        filtros.proyectoPagoVersionId = vm.itemSeleccionado.proyecto_pago_version_id
        filtros.ordenPagoId = vm.itemSeleccionado.id
        return ProyectoPago.obtenerComprobantesOrdenPago(
          filtros.proyectoPagoVersionId,
          filtros.ordenPagoId,
          filtros
        )
      }
    },

    sumaImporteItemsComprobantes (comprobantes) {
      let valor = _.sumBy(comprobantes, item => {
        return this.info.comprobantesRestan.indexOf(item.comprobante.tipo_comprobante.codigo) > -1
          ? Number(item.importe_pagado) * -1
          : Number(item.importe_pagado)
      })
      return valor || 0
    }
  }
}
</script>
<style scoped></style>
